import * as React from "react";
import { AriaRadioProps, useRadio, VisuallyHidden } from "react-aria";

import { RadioGroupState } from "react-stately";
import { StyleProps } from "../../utils/types";
import { cx } from "../../utils/dom";
import { RadioContext } from "./radio";

interface RadioItemProps extends AriaRadioProps, StyleProps<"wrapper"> {
  children?: React.ReactNode;
}

export function RadioItem({
  className,
  style,
  classNames,
  styles,
  ...props
}: RadioItemProps) {
  const state = React.useContext(RadioContext);
  if (!state) throw new Error("RadioItem must be used within a RadioGroup");

  const ref = React.useRef(null);
  const { inputProps } = useRadio(props, state as RadioGroupState, ref);

  return (
    <label
      style={{ ...style, ...styles?.wrapper }}
      className={cx(className, classNames?.wrapper, "p-radio-item")}
      data-checked={inputProps.checked}
    >
      <VisuallyHidden>
        <input {...inputProps} ref={ref}></input>
      </VisuallyHidden>
      {props.children}
    </label>
  );
}
